import { autoserialize, inheritSerialization } from 'cerialize';
import { AbstractModel } from '@uzurv/core';

@inheritSerialization(AbstractModel)
export class DocumentField extends AbstractModel {
  @autoserialize
  name: string;

  @autoserialize
  label: string;

  @autoserialize
  description: string;

  @autoserialize
  isActive: boolean;

  @autoserialize
  documentTypeId: number;
}
